import packageInfo from '../../package.json';

const wsServer = 'wss://api.bookings.ai.media';
const apiServer = 'https://api.bookings.ai.media';
const server = 'https://idam-prod-ap-southeast-2.idam.ai.media';
const appClientId = '35v67qhmrne5jbrvo0qpum6e6j';
const pk = 'pk_test_51IXThGBsh7vCSivuCtJfxtYHbLgXtvBZHGLfYd0hRimbYhMgwa1XH0dRvmerQk63iBoK1A9ob79oDSQTNA7cYoa500z2Ng58yq';
const disableProgressBar = 8;
const bookingPageSize = 450;
const serverURL = 'https://bookings.ai.media/'
const viewerUrl = 'https://bookings.ai.media/viewer/event?id='
const calendarUrl = 'https://api.bookings.ai.media/v1/cal/ics/'
const aiLive = 'https://us.ai-live.com/CaptionViewer/Join/thirdparty?iFrame=1&sessionId=';
const aiLiveDomainUrls = {
  us: 'https://us.ai-live.com/CaptionViewer/Join/thirdparty?iFrame=1&sessionId=',
  au: 'https://au.ai-live.com/CaptionViewer/Join/thirdparty?iFrame=1&sessionId=',
  uk: 'https://uk.ai-live.com/CaptionViewer/Join/thirdparty?iFrame=1&sessionId='
}
const logErrors = false;
const samApiToken = '068316a5-a075-472a-ab21-40cc037cd977';
const showPrivateLinkBE = 17
export const environment = {
  production: true,
  appVersion: packageInfo.version,
  wsServer,
  apiServer,
  disableProgressBar,
  bookingPageSize,
  aiLiveDomainUrls,
  whiteLabelUrls: {
    'us': 'https://us.ai-live.com/CaptionViewer/Join/WhiteLabel',
    'au': 'https://au.ai-live.com/CaptionViewer/Join/WhiteLabel',
    'uk': 'https://uk.ai-live.com/CaptionViewer/Join/WhiteLabel'
  },
  aiLiveSmartLink: {
    'us': "https://us.ai-live.com/Join/InstantLexi?",
    'au': 'https://au.ai-live.com/Join/InstantLexi?',
    'uk': "https://uk.ai-live.com/Join/InstantLexi?"
  },
  aiLiveDomainKeys: {
    Americas: 'us',
    APAC: 'au',
    EMEA: 'uk'
  },
  restrictDirectMicrophoneToEnglish: true,
  hideCaptionTranslations: true,
  aiLive,
  viewerUrl,
  serverURL,
  samApiToken,
  multipleBrowserWarningEnabled: false,
  showPrivateLinkBE,
  logErrors,
  ai_media_contact_url: 'https://www.ai-media.tv/#start-a-conversation',
  calendarUrl,
  booking: {
    // minimal booking duration
    minimumDuration: 30, // minutes
    // minimum duration to be paid (customer will have paid for this time even if real session will last shorter)
    minimumPaidDuration: 60, // minutes
    fixedFee: 0, // Temporary gap - should be rewritten
    minimumPaidChunk: 15, // minutes
    minimumPeriodToModify: 24, // hours
        maxPrepMaterialSize: 35, // MB
    minimumEffectiveCreationPeriod: 1440, // minutes,

    // booking jobs limits
    maxBookingSeries: 31, // 1 month
    maxBookingYear: 365,
    maxBookingHalfYear: 365,
    maxBookingQuarterYear: 365,
    maxSampleLimit: 10,

    // guest booking
    minGuestDate: 1,
    guestBookingEnabled: true,
  },
  messages: {
    RECONNECT_ATTEMPTS: 10,
    RECONNECT_INTERVAL: 1000 * 1,
    TIMEOUT: 10000,
  },
  instant_lexi: {
    default: 60,
    min: 0,
    max: 100,
    max_hours: 8,
    minute_intervals: 15,
    create_lead_mins: 2,
    session_link_max_retry: 180
  },
  summarization_limits: {
    TIMEOUT: 120
  },
  participants_limits: {
    viewers: 25,
    speakers: 25
  },
  stripe: {
    pk
  },
  useLocalAuth: false,
  sso: {
    server,
    appClientId
  },
  users: {
    password: {
      regex: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-+_!@#$%^&*., ?]).{8,}/
    }
  },
  show_ml_instant_lexi: true,
  enable_ai_live_lexi_audio_selection: true
};
